<template>
  <div class="col-lg-12 control-section">
    <div class="tree-control-wrapper">
      <ejs-treeview ref='neTreeForNoRealTaskModify' id='neTreeForNoRealTaskModify' :fields='fields' :nodeSelected="nodeSelectedOfNoRealTaskResourceTree"></ejs-treeview>
    </div>
  </div>
</template>

<script>

import CommonUtil from "../../../../util/CommonUtil";

export default {
  name: 'NeTreeForNoRealTaskModify',
  props: [
    'addOrModifyTaskFlag',
    'neIdsUnderTaskByTaskId'
  ],
  data() {
    return {
      fields: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        iconCss: 'iconCls'
      },
    };
  },
  methods: {
    nodeSelectedOfNoRealTaskResourceTree(args) {
      const selectNode = this.$refs.neTreeForNoRealTaskModify.getTreeData(args.nodeData.id)[0];
      const childrenLength = selectNode.children.length;
      let measureTreeTypeForNoRealTaskModify = 1;
      if (childrenLength == 0) {
        if(selectNode.attributes.neSwitch == 2){
          measureTreeTypeForNoRealTaskModify = 3; //任务已经存在
        }else if(selectNode.attributes.neSwitch == 3){
          measureTreeTypeForNoRealTaskModify = 4; //网元不在线
        }else {
          this.$parent.$refs.MeasureTreeForNoRealTaskModify.getMeasureObjTreeFoNoRealTaskModify(selectNode.attributes.neTypeId, selectNode.attributes.neId);
          measureTreeTypeForNoRealTaskModify = 1;
        }
      }else{
        measureTreeTypeForNoRealTaskModify = 2; //未选择正确的网元节点
      }
      this.$emit('measureTreeShowTypeChange', measureTreeTypeForNoRealTaskModify);
    },
    getResourceTreeForNoRealTaskModify(neTypeCode,cycle) {

      const params = {
        neTypeCode: neTypeCode,
        sampleTime: cycle
      }
      this.$axios.post(`/lte/ems/pm/noReal/task/buildNoRealTaskResourceTreeForModify.html${CommonUtil.analyticParameter(params)}`).then((response) => {
        this.fields = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state',
          iconCss: 'iconCls'
        };
      });
    }
  },
  mounted() {
  }
};
</script>

<style>

</style>
